import { BaseEntity } from '../core/entities/base.entity';
import { Relation } from '../core/decorators/relation.decorator';
import { RelationRef } from '../core/types/entity-types';
import { ModuleEntity } from './module.entity';
import { LearningUnitEntity } from '../learning-unit/learning-unit-entity';

export class ModuleLearningUnitMetadataEntity extends BaseEntity {
  cantonKey!: string;
  professionKey!: string;

  @Relation()
  module?: RelationRef<ModuleEntity>;

  @Relation()
  learningUnit?: RelationRef<LearningUnitEntity>;
}
